import { render, staticRenderFns } from "./organizeblog2.component.vue?vue&type=template&id=e356d2a8&scoped=true"
import script from "./organizeblog2.component.vue?vue&type=script&lang=js"
export * from "./organizeblog2.component.vue?vue&type=script&lang=js"
import style0 from "./organizeblog2.component.vue?vue&type=style&index=0&id=e356d2a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e356d2a8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
